import React, { useEffect } from 'react';
import styled, { keyframes } from 'styled-components';

interface NotificationAnimationProps {
  isActive: boolean;
  onAnimationEnd?: () => void;
}

const NotificationAnimation: React.FC<NotificationAnimationProps> = ({ 
  isActive,
  onAnimationEnd
}) => {
  useEffect(() => {
    if (isActive) {
      // 动画结束后触发回调
      const timer = setTimeout(() => {
        if (onAnimationEnd) {
          onAnimationEnd();
        }
      }, 4000); // 4秒后结束动画
      
      return () => clearTimeout(timer);
    }
  }, [isActive, onAnimationEnd]);
  
  return (
    <AnimationContainer className={isActive ? 'active' : ''}>
      <GlowBorder className="top" />
      <GlowBorder className="right" />
      <GlowBorder className="bottom" />
      <GlowBorder className="left" />
    </AnimationContainer>
  );
};

// 颜色变化动画
const colorChange = keyframes`
  0% { background-color: rgba(255, 102, 102, 0.35); }
  25% { background-color: rgba(255, 153, 102, 0.35); }
  50% { background-color: rgba(255, 187, 102, 0.35); }
  75% { background-color: rgba(255, 102, 153, 0.35); }
  100% { background-color: rgba(255, 102, 102, 0.35); }
`;

// 阴影模糊范围变化
const glowPulse = keyframes`
  0% { box-shadow: 0 0 14px 1px rgba(255, 102, 102, 0.2); }
  25% { box-shadow: 0 0 36px 12px rgba(255, 153, 102, 0.3); }
  50% { box-shadow: 0 0 17px 3px rgba(255, 187, 102, 0.4); }
  75% { box-shadow: 0 0 36px 12px rgba(255, 102, 153, 0.3); }
  100% { box-shadow: 0 0 14px 1px rgba(255, 102, 102, 0.2); }
`;

// 淡入淡出动画
const fadeInOut = keyframes`
  0% { opacity: 0; }
  10% { opacity: 1; }
  90% { opacity: 1; }
  100% { opacity: 0; }
`;

const AnimationContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 9999;
  
  &:not(.active) {
    display: none;
  }
  
  &.active {
    animation: ${fadeInOut} 2s ease-in-out forwards;
  }
`;

const GlowBorder = styled.div`
  position: absolute;
  background-color: rgba(255, 102, 102, 0.15);
  animation: ${colorChange} 2s infinite ease-in-out, ${glowPulse} 4s infinite ease-in-out;
  filter: blur(2px);
  
  &.top {
    top: 0;
    left: 0;
    width: 100%;
    height: 2px;
  }
  
  &.right {
    top: 0;
    right: 0;
    width: 2px;
    height: 100%;
  }
  
  &.bottom {
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
  }
  
  &.left {
    top: 0;
    left: 0;
    width: 2px;
    height: 100%;
  }
  
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    filter: blur(4px);
    animation: ${colorChange} 4s infinite ease-in-out;
    animation-delay: 0.5s;
    opacity: 0.7;
  }
`;

export default NotificationAnimation; 